import request from 'superagent';
import _ from 'lodash';
import PageContainer from './PageContainer';
import session from '../models/Session';
import Draft from '../models/Draft';

import mockCardsList from '../pages/__mocks__/cardsList.json';
import mockTemplates from '../containers/__mocks__/templates.json';
import config from '../config';

export default class DraftTitleAndBlurbContainer extends PageContainer {
  state = {
    title: '',
    blurb: '',
    image: '',
    template: (mockTemplates || []).filter(t => /Issue/i.test(t.name)).pop(),
    draft: null,
    file: {},
    completed: 0,
  }

  options = {
    getFromSession: ['template', 'draft'],
    defaultState: {
      draft: Draft.mock().fetchLocal(),
      selectedParents: [...mockCardsList.genreMany.slice(0,2)]
    },

    flags: [{
      name: 'isLoaded',
      check: () => true,
    }],
  }

  handleChange = (e) => {
    this.state.draft.set(e.target.name, e.target.value);
    // this.setState({
    //   [e.target.name]: e.target.value, 
    //   draft: this.state.draft.set(e.target.name, e.target.value)
    // })
  }
  
  handleDropFile = (files) => {
    console.log('Drop file', files);
    const file = files.shift();
    this.state.draft.set('image', {...file});
    console.log(this.state.draft.toObject());
    // this.state.draft.syncImage(file);


    const data = new FormData();
    data.append('image', file);

    // const req = request.post(`${config.backend.uri}/upload`);
    const req = request.post('http://alb-storyjam-backend-495553203.us-east-1.elb.amazonaws.com/upload');

    req.on('progress', (event) => {
      const percent = Math.floor(event.percent);
      if (percent >= 100) {
        this.setState({ completed: 100 });
      } else {
        this.setState({ completed: percent });
      }
    });
    req.send(data);
    req.end((err, res) => {
      this.state.draft.set('image', { ...file, ...res.body.data.upload });
    });
  }

  async setup() {
    await this.subscribeToSession();

    if (!this.state.draft) {
      await session.fetchLocal();
      // await this.setState(state => _.assign(state, this.options.defaultState));
    }

    this.state.draft.changes$.subscribe((data) => {
      this.state.draft.save();
      session.save();
    });

    this.subscribeToStore(this.state.draft, ['title', 'blurb', 'image']);
  }

  destroy() {
    this.unsubscribeAll();
    URL.revokeObjectURL(this.state.image);
  }
}



// WEBPACK FOOTER //
// ./src/containers/DraftTitleAndBlurbContainer.js